import React, { useState } from 'react';
import Allbooks from "../book/Allbooks";
import AllCourses from "../courses/AllCourses";
import AllBorrowsbooks from "../borrows/AllBorrowsbooks";
import { useTranslation } from "../../context/TranslationContext";
import SectionTabs from "../../component/SectionTabs"; 

export default function Shop() {
  const { translations, language } = useTranslation();
  const isArabic = language === "ar";

  const sections = {
    allbooks: {
      label: translations.availableBooks,
      component: <Allbooks />,
    },
    allBorrowsbooks: {
      label: translations.availableBorrowsbooks,
      component: <AllBorrowsbooks />,
    },
    allCourses: {
      label: translations.availableCourses,
      component: <AllCourses />,
    },
  };

  const [selectedSection, setSelectedSection] = useState("allbooks");

  const handleSelectChange = (event) => {
    setSelectedSection(event.target.value);
  };

  return (
    <div className={`flex ${isArabic ? 'flex-col md:flex-row' : 'flex-col-reverse md:flex-row-reverse'} pt-24 w-full`}>
      <div
    dir={isArabic ? "rtl" : "ltr"}
    className={`flex-1 font-tajwal ${isArabic ? ' text-right' : ' text-left'}`}
      >
        <h2 className="text-xl font-bold mb-1">{translations.shop}</h2>
        <h4 className="text-l font-bold text-gray-500 mb-4">{translations.shopDescription}</h4>

        {/* Section Tabs for small screens */}
        <SectionTabs
          sections={sections}
          selectedSection={selectedSection}
          onChange={handleSelectChange}
        />

        {/* Buttons for larger screens */}
        <div className="hidden sm:flex flex-wrap justify-center md:justify-start gap-2 mt-4">
          {Object.entries(sections).map(([key, section]) => (
            <button
              key={key}
              onClick={() => setSelectedSection(key)}
              className={`flex items-center px-4 py-2 rounded-lg text-l font-bold text-gray-900 bg-blue hover:bg-primary-blue hover:text-white focus:outline-none ${
                selectedSection === key ? "bg-primary-blue text-white" : ""
              }`}
            >
              {section.label}
            </button>
          ))}
        </div>

        <hr className="my-2 border-gray-200 mb-10" />

        {/* Section Content */}
        {sections[selectedSection]?.component}
      </div>
    </div>

    
  );
}
